import React from "react";

// Phase 65 follow-up: a form recipient may be EXTERNAL -- an email address
// with no portal account (form_assignment_users.user_id NULL +
// recipient_email; first used by the ERP training User Feedback campaign).
// The backend now returns those rows everywhere (admin assignment list,
// review queue, responses, execution reports, report exports) with an
// `is_external` flag and the recipient's email/name already in the usual
// name/email fields. This one badge is what every list renders next to such a
// row, so "External" always looks the same and registered rows are untouched
// (renders nothing unless `external` is truthy).
export function isExternalRecipient(row) {
  if (!row) return false;
  return row.is_external === true || row.is_external === 1 || row.is_external === "1" || row.isExternal === true;
}

export default function ExternalRecipientBadge({ external, className = "" }) {
  if (!external) return null;
  return (
    <span
      className={`badge bg-info text-dark ms-1 external-recipient-badge ${className}`.trim()}
      title="External recipient -- email address only, no portal account"
      data-testid="external-recipient-badge"
    >
      External
    </span>
  );
}
